import { FileUploadEngine, UploadOptions } from '@publicsafety/fileupload';
import { FileUploadEvent, BaseEventData } from '@publicsafety/fileupload';

import { FileUploadEventStore } from '@publicsafety/fileupload';
import { useContextDataStore } from '@/VueCore/stores/contextDataStore';
import UploadModel from '@/Models/uploadModel';

export default class FlowWrapper {
  static init = () => {
    const uploadOptions = new UploadOptions();
    const contextData = useContextDataStore();
    uploadOptions.fileUploadServiceBaseUrl = contextData.portalSettings.fileUploadServiceRootUrl;
    uploadOptions.simultaneousChunkUploads = contextData.portalSettings.maximumConcurrentUploads;
    uploadOptions.chunkSize = contextData.portalSettings.maximumChunkSize;

    FileUploadEngine.init(uploadOptions);

    // Prevent the browser default drag and drop behavior
    document.addEventListener('dragover', e => {
      e.preventDefault();
    });

    document.addEventListener('drop', e => {
      e.preventDefault();
    });
  };

  static subscribeTo(event: FileUploadEvent, callback: (data: BaseEventData) => void) {
    FileUploadEventStore.subscribe({
      eventId: event,
      eventHandler: callback
    });
  }

  static addFileUpload = (upload: UploadModel) => {
    const fileUploads = [{
      id: upload.uploadId,
      uploadToken: upload.uploadToken,
      nativeFile: upload.nativeBrowserFile
    }];
    FileUploadEngine.addFileUploads(fileUploads);
  };

  static cancelFileUpload = (nativeFile: File) => {
    FileUploadEngine.cancelFileUpload(nativeFile);
  };
}